import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faChevronLeft,
  faChevronRight
} from '@fortawesome/free-solid-svg-icons'
import { useEffect, useState } from 'react'
const CustomSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    nextArrow: (
      <div className='arrow right'>
        <FontAwesomeIcon
          icon={faChevronRight}
          style={{ color: '#f8ac19', fontSize: '30px' }}
        />
      </div>
    ),
    prevArrow: (
      <div className='arrow left'>
        <FontAwesomeIcon
          icon={faChevronLeft}
          style={{ color: '#f8ac19', fontSize: '30px' }}
        />
      </div>
    )
  }
  const [SliderImageWithText, setSliderImageWithText] = useState([])
  useEffect(() => {
    fetch('/PackageJson/Home/SliderImages.json')
      .then(response => response.json())
      .then(data => {
        setSliderImageWithText(data)
      })
      .catch(error => console.error('Error loading JSON:', error))
  }, [SliderImageWithText])

  return (
    <div
      className='BeautifulThailand'
      style={{ position: 'relative', overflow: 'hidden' }}
    >
      <Slider {...settings}>
        {SliderImageWithText?.map(item => (
          <div key={item.displayOrder} className='slide'>
            <img
              style={{
                overflowClipMargin: 'unset',
                objectPosition: 'center',
                filter: 'brightness(0.8)',
                height: '80vh',
                objectFit: 'cover',
                width: '100%'
              }}
              src={item.ImagesPath}
              alt={item.displayOrder}
            />
          </div>
        ))}
      </Slider>
    </div>
  )
}

export default CustomSlider
